import { inject, observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router-dom';

import { ExpandLess, ExpandMore } from '@mui/icons-material';
import Collapse from '@mui/material/Collapse';

import Hubspot from 'app/main/common/Hubspot';
import Hljs from 'main/components/Hljs';

@inject('userStore')
@inject('scanWizardStore')
@observer
export default class Results extends React.Component {
    state = {
        openAdvanced: false
    };

    componentDidMount() {
        const { email } = this.props.userStore.user;
        Hubspot.send(Hubspot.LINUX_SCANNER_NEW_INSTALLATION_FINISHED, { email });
    }

    render() {
        const { openAdvanced } = this.state;

        return (
            <div>
                <h3>Agent execution</h3>

                <p>
                    During first run agent will automatically register with configured api_key After this you may look
                    at{' '}
                    <Link style={{ color: '#ff6600', textDecoration: 'none' }} to="/linux-scanner">
                        agent status and scanning results
                    </Link>
                </p>

                <br />

                <div
                    style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    onClick={() => this.setState({ openAdvanced: !openAdvanced })}
                >
                    <h3>Advanced configuration</h3>
                    {openAdvanced ? <ExpandLess /> : <ExpandMore />}
                </div>

                <Collapse in={openAdvanced}>
                    Using <b>/etc/vulners/vulners_agent.conf</b> you can override part of the identification parameters.
                    <Hljs language="bash" className="bash">
                        [DEFAULT]
                        <br />
                        api_key = RGB9YPJG7CFAXP35PMDVYFFJPGZ9ZIRO1VGO9K9269B0K86K6XQQQR32O6007NUK
                        <br />
                        <br />
                        [Ticker]
                        <br />
                        ip_address = 10.0.0.1
                        <br />
                        fqdn = my.host.example.com
                        <br />
                        mac_address = 00:01:02:03:04:06
                        <br />
                    </Hljs>
                </Collapse>
            </div>
        );
    }
}
